module.exports = __webpack_public_path__ + "static/media/banner_3.901d5ef0.png";